export type IntakeChoice = {
	value: string;
	label: string;
	imageSrc?: string;
	imageAlt?: string;
};

export type IntakeAnswers = {
	homeType: string;
	projectTimeline: string;
	serviceArea: string;
	street: string;
	city: string;
	state: string;
	zip: string;
	firstName: string;
	phone: string;
	email: string;
	smsConsent: boolean;
};

export const EMPTY_INTAKE_ANSWERS: IntakeAnswers = {
	homeType: '',
	projectTimeline: '',
	serviceArea: '',
	street: '',
	city: '',
	state: 'TX',
	zip: '',
	firstName: '',
	phone: '',
	email: '',
	smsConsent: false,
};

export const HOME_TYPE_OPTIONS: IntakeChoice[] = [
	{
		value: 'single-family',
		label: 'Single family home',
		imageSrc: '/assets/img/intake/single-family.png',
		imageAlt: 'Modern single family home with landscaped yard',
	},
	{
		value: 'townhouse-duplex',
		label: 'Townhouse or duplex',
		imageSrc: '/assets/img/intake/townhouse-duplex.png',
		imageAlt: 'Townhouse or duplex building with shared landscaping',
	},
	{
		value: 'mobile-other',
		label: 'Mobile home or other',
		imageSrc: '/assets/img/intake/mobile-other.png',
		imageAlt: 'Modern mobile or tiny home on a landscaped lot',
	},
	{
		value: 'commercial',
		label: 'Commercial building',
		imageSrc: '/assets/img/intake/commercial.png',
		imageAlt: 'Commercial office building with plaza landscaping',
	},
];

export const TIMELINE_OPTIONS: IntakeChoice[] = [
	{ value: 'asap', label: 'As soon as possible' },
	{ value: 'this-month', label: 'This month' },
	{ value: 'next-month', label: 'Next month' },
	{ value: 'no-preference', label: 'No preference' },
];

export const SERVICE_AREA_OPTIONS: IntakeChoice[] = [
	{ value: 'austin', label: 'Austin' },
	{ value: 'dallas-fort-worth', label: 'Dallas-Fort Worth' },
	{ value: 'houston', label: 'Houston' },
	{ value: 'san-antonio', label: 'San Antonio' },
	{ value: 'somewhere-else', label: 'Somewhere else' },
];

export const INTAKE_STEP_COUNT = 5;
